import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
  name: 'age'
})
export class AgePipe implements PipeTransform {

  transform(value: string, ...args: unknown[]): string {
    const dob = moment(value);
    let age: number | undefined;

    if (typeof value === 'string' && dob.isValid()) {
      age = moment().diff(dob, 'years');
    }

    return age !== undefined ? `${age} yrs` : value
  }
}
